import React from "react";
import { getClassNameFactory } from "../../../../../../utilities/classNames/";
import DateTime from "../../../../../../elements/DateTime/";
import Duration from "../../../../../../elements/Duration/";

var ArticleInfoFooter = function ArticleInfoFooter(_ref) {
  var dateTime = _ref.dateTime,
      duration = _ref.duration,
      durationText = _ref.durationText,
      name = _ref.name;
  var getClassName = getClassNameFactory("SearchResults");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "articleInfoFooter"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "articleInfoFooterMetadata"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "articleInfoFooterDate"
    })
  }, /*#__PURE__*/React.createElement(DateTime, {
    dateTime: dateTime,
    format: "LL"
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: getClassName({
      descendantName: "articleInfoFooterDot"
    }),
    role: "presentation"
  }, " • "), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "articleInfoFooterName"
    })
  }, name)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "articleInfoFooterDuration"
    })
  }, /*#__PURE__*/React.createElement(Duration, {
    duration: duration
  }, durationText)));
};

export default ArticleInfoFooter;